export const styles = theme => ({
  inputStylePerItem: {
    width: '65px',
    height: '10px',
  },
});
